import { StoryTracker } from "../../../sim/singletons/StoryTracker";
import { useGame, useShellVersion } from "../../useShell";

/** Whether a story scene is up right now, as React state. */
export function useScenePlaying(): boolean {
  const game = useGame();
  useShellVersion();
  return game.entities.tryGetSingleton(StoryTracker)?.playing != null;
}
